import { ModuleManager, SectionList } from "@module-system";

import PhotoButtonVue from "./Components/PhotoButton.vue";
import PhotoPanelVue from "./Components/PhotoPanel.vue";
import PhotoDocumentSelection from "./Components/PhotoDocumentSelection.vue";
import locales from "./locales";
import CommonConditions from "@lib/commonConditions";
import PhotoTypeSelection from "./Components/PhotoTypeSelection.vue";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "Photo",
  version: "1.0.0",
  register() {
    const photoButtonConfig = window.CONFIG?.CALL_BUTTONS?.PHOTO ?? {};
    photoButtonConfig.ENABLED = photoButtonConfig.ENABLED ?? true;
    photoButtonConfig.ORDER = photoButtonConfig.ORDER ?? 40;

    ModuleManager.addLocales(locales, "Photo");

    ModuleManager.addViewModule({
      key: "photo-button",
      order: photoButtonConfig.ORDER,
      section: SectionList.CallButtonsList,
      ViewComponent: PhotoButtonVue,
      Condition: (rtcId) => CommonConditions.isAgent(rtcId) && photoButtonConfig.ENABLED,
      stackable: false,
    });

    ModuleManager.addViewModule({
      key: "photo-panel",
      order: 1,
      section: SectionList.CallRightPanel,
      ViewComponent: PhotoPanelVue,
      tabTitle: "Photos",
      size: 300,
      Condition: (rtcId) =>
        (CommonConditions.isAgent(rtcId) || CommonConditions.isSupervisor(rtcId)) && photoButtonConfig.ENABLED,
    });

    ModuleManager.addViewModule({
      key: "photo-document-selection",
      order: 1,
      section: SectionList.CallBottomPanel,
      ViewComponent: PhotoDocumentSelection,
      size: 100,
      Condition: (rtcId) => CommonConditions.isAgent(rtcId) && photoButtonConfig.ENABLED,
    });

    ModuleManager.addViewModule({
      key: "photo-type-selection",
      order: 1,
      section: SectionList.CallModal,
      ViewComponent: PhotoTypeSelection,
      size: 100,
      Condition: (rtcId) => CommonConditions.isAgent(rtcId) && photoButtonConfig.ENABLED,
    });
  },
};
export default module;
